
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { BarChart } from "@/components/ui/chart";
import type { SubscriberGrowthItem } from "@/hooks/useNewsletterStats";

interface SubscriberGrowthChartProps {
  subscriberGrowth: SubscriberGrowthItem[];
  isLoading: boolean;
  height?: number;
}

export function SubscriberGrowthChart({ 
  subscriberGrowth, 
  isLoading,
  height = 250 
}: SubscriberGrowthChartProps) {
  if (isLoading) {
    return <Skeleton className={`w-full h-[${height}px]`} />;
  }

  const chartData = {
    labels: subscriberGrowth.map(item => item.date),
    datasets: [
      {
        label: 'New Subscribers',
        data: subscriberGrowth.map(item => item.new_subscribers),
        backgroundColor: 'rgba(16, 185, 129, 0.7)',
        borderColor: 'rgb(16, 185, 129)',
        borderWidth: 1,
      },
      {
        label: 'Unsubscribed',
        data: subscriberGrowth.map(item => item.unsubscribed),
        backgroundColor: 'rgba(239, 68, 68, 0.7)',
        borderColor: 'rgb(239, 68, 68)',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0
        }
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          footer: (tooltipItems: any) => {
            const datasetIndex = tooltipItems[0].datasetIndex;
            const index = tooltipItems[0].dataIndex;
            
            if (datasetIndex === 0) {
              const unsubscribed = subscriberGrowth[index].unsubscribed;
              const netGrowth = subscriberGrowth[index].new_subscribers - unsubscribed;
              return `Net Growth: ${netGrowth > 0 ? '+' : ''}${netGrowth}`;
            }
            return '';
          },
        }
      }
    }
  };

  return (
    <div style={{ height: `${height}px` }}>
      <BarChart 
        data={chartData} 
        options={chartOptions}
        className="w-full h-full" 
      />
    </div>
  );
}
